<sm-title-bar pageTitle="Report"></sm-title-bar>

